import { useState, type FormEvent } from 'react';
import { LoaderCircle, MessageSquareText, Send, X } from 'lucide-react';
import { useExperience } from '../content/ExperienceContext';
import { useSiteCopy } from '../content/SiteCopyContext';

export function FeedbackDialog() {
  const copy = useSiteCopy();
  const { locale } = useExperience();
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const [contact, setContact] = useState('');
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (content.trim().length < 5 || loading) return;
    setLoading(true); setNotice('');
    try {
      const response = await fetch('/api/feedback', {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content, contact, locale, pageUrl: window.location.href })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.message || copy('feedback.error'));
      setContent(''); setContact(''); setNotice(copy('feedback.success'));
    } catch (reason) { setNotice(reason instanceof Error ? reason.message : copy('feedback.error')); }
    finally { setLoading(false); }
  }

  return <>
    <button className="feedback-fab" type="button" onClick={() => { setOpen(true); setNotice(''); }} aria-label={copy('feedback.open')}><MessageSquareText size={19} /><span>{copy('feedback.open')}</span></button>
    {open && <div className="modal-backdrop feedback-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget) setOpen(false); }}>
      <section className="feedback-dialog" role="dialog" aria-modal="true" aria-labelledby="feedback-title">
        <button className="icon-button feedback-close" type="button" onClick={() => setOpen(false)} aria-label={copy('feedback.close')}><X size={19} /></button>
        <div className="feedback-heading"><MessageSquareText size={24} /><div><h2 id="feedback-title">{copy('feedback.title')}</h2><p>{copy('feedback.intro')}</p></div></div>
        <form onSubmit={submit}>
          <label htmlFor="feedback-content">{copy('feedback.contentLabel')}</label>
          <textarea id="feedback-content" value={content} onChange={(event) => setContent(event.target.value)} maxLength={3000} rows={7} placeholder={copy('feedback.contentPlaceholder')} required />
          <label htmlFor="feedback-contact">{copy('feedback.contactLabel')}</label>
          <input id="feedback-contact" value={contact} onChange={(event) => setContact(event.target.value)} maxLength={200} placeholder={copy('feedback.contactPlaceholder')} />
          {notice && <p className="feedback-notice" role="status">{notice}</p>}
          <button className="primary-button feedback-submit" type="submit" disabled={content.trim().length < 5 || loading}>{loading ? <><LoaderCircle className="spin" size={16} />{copy('feedback.submitting')}</> : <><Send size={16} />{copy('feedback.submit')}</>}</button>
        </form>
      </section>
    </div>}
  </>;
}
